import React, { ReactElement } from 'react';
import { Typography } from '@wds/typography';
import { List } from '@wds/list';
import { Box } from '@wds/box';
import { Immutable } from '@wds/utils';
import { Responsive } from '@wds/responsive';
import { SubMenuItem } from '../mobile-nav/SubMenuItem';
import useStyles from './useStyles';

type MenuItemType = Immutable<{
  title: string;
  url: string;
  subTitle: string;
  openInNewWindow?: boolean;
}>;

const MenuItems = ({
  title,
  url,
  subTitle,
  openInNewWindow = false,
}: MenuItemType): ReactElement => {
  const classes = useStyles();
  return (
    <Responsive minWidth="xl">
      {matches =>
        matches ? (
          <List.Item
            interactive
            noRules
            isNavigable
            href={url}
            {...(openInNewWindow === true && {
              target: '_blank',
              rel: 'noopener noreferrer',
            })}
          >
            <Box py={4}>
              <Typography variant="body">{title}</Typography>
              <Box pt={1} display="flex" className={classes.descriptionBox}>
                <Typography variant="bodySm">{subTitle}</Typography>
              </Box>
            </Box>
          </List.Item>
        ) : (
          <SubMenuItem title={title} url={url} />
        )
      }
    </Responsive>
  );
};

export default MenuItems;
export { MenuItems };
